<template>
  <BaseModal
    v-model="model"
    title="Visualizador de documento"
    :show-footer="false"
    :loading="loading"
    :scrollable="false"
    size="xl"
  >
    <iframe
      v-if="pdfUrl"
      :src="pdfUrl"
      style="width: 100%; height: 80vh; border: none;"
    />
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/ui/modal/BaseModal.vue'
import ApiRestService from '@/api/base-api'

export default {
  name: 'PdfViewerModal',
  components: { BaseModal },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    archiveId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      pdfUrl: null,
    }
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
  watch: {
    value(val) {
      if (val && this.archiveId) {
        this.fetchPdf()
      } else if (!val) {
        this.revokePdfUrl()
      }
    },
  },
  beforeDestroy() {
    this.revokePdfUrl()
  },
  methods: {
    async fetchPdf() {
      this.loading = true
      try {
        this.pdfUrl = await ApiRestService.showArchive(this.archiveId)
      } finally {
        this.loading = false
      }
    },
    revokePdfUrl() {
      if (this.pdfUrl) {
        URL.revokeObjectURL(this.pdfUrl)
        this.pdfUrl = null
      }
    },
  },
}
</script>
